// removed by extract-text-webpack-plugin
module.exports = {"blockContainer":"_3hAZK","block":"_1f4Lx","root":"_28uwx"};